import type { Essentials } from '../../../models';
import type { AppGroupSection } from '../../../types/sections';
import type { Category } from './category';
import { getCategory } from './category';
import { getAppGroupSectionsBySubCategoriesIds } from './sections';

export async function getCategoryPageData({
  httpClient,
  rpcClient,
  slug,
  languageCode,
}: {
  httpClient: Essentials['httpClient'];
  rpcClient: Essentials['rpcClient'];
  slug: string;
  languageCode: string;
}): Promise<{
  category: Category;
  appGroupSections: AppGroupSection[];
}> {
  const category = await getCategory({
    httpClient,
    rpcClient,
    slug,
    languageCode,
  });
  const appGroupSections = await getAppGroupSectionsBySubCategoriesIds({
    httpClient,
    rpcClient,
    subCategoriesIds: category.subCategoriesIds,
  });

  return {
    category,
    appGroupSections,
  };
}
